var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcFreeBalloon = function SvgIcFreeBalloon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EF4239",
    fillRule: "evenodd",
    d: "M5.424 9.27s-.899 1.081-.077 1.17h.91s.548-.106.105-.815l-.336-.354",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M5.424 9.27s-.899 1.081-.077 1.17h.91s.548-.106.105-.815l-.336-.354"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB21C",
    fillRule: "evenodd",
    d: "M9.267 9.439s.133.425-.105.788c0 0-.378.46-.804.124 0 0-.812-.497-.245-.852 0 0 .277-.202.606-.324",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M9.267 9.439s.133.425-.105.788c0 0-.378.46-.804.124 0 0-.812-.497-.245-.852 0 0 .277-.202.606-.324M5.768 10.44c.154.484.545 1.578 1.406 2.435 0 0 1.032 1.26.585 2.403"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M8.282 10.3s-1.392 1.203-.897 2.903c0 0 .403.744-.978 1.98"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M7.488 13.393s-1.685-1.24-2.1.155c0 0 .03 1.316 2.052-.053 0 0 .835-2.382 1.722-1.155 0 0 .654.987-1.674 1.053",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB21C",
    fillRule: "evenodd",
    d: "M8.269 3.528c.795-.834 1.918-1.227 2.996-.932 1.655.452 2.576 2.356 2.058 4.253-.519 1.896-2.28 3.067-3.936 2.614-.727-.199-1.312-.677-1.696-1.313",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M8.269 3.528c.795-.834 1.918-1.227 2.996-.932 1.655.452 2.576 2.356 2.058 4.253-.519 1.896-2.28 3.067-3.936 2.614-.727-.199-1.312-.677-1.696-1.313"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#EF4239",
    fillRule: "evenodd",
    d: "M8.449 4.439c.243 2.265-.923 4.545-2.695 4.736-1.773.19-3.48-1.782-3.724-4.048C1.787 2.862 3.027.871 4.8.681 6.572.491 8.206 2.174 8.449 4.44",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M8.449 4.439c.243 2.265-.923 4.545-2.695 4.736-1.773.19-3.48-1.782-3.724-4.048C1.787 2.862 3.027.871 4.8.681 6.572.491 8.206 2.174 8.449 4.44",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5.333,
    height: 5.333,
    x: 10.667,
    fill: "#EF4239",
    rx: 2.667
  })));
};
export default SvgIcFreeBalloon;